export default function () {
  return {
    fab: true
  }
}
